export default __webpack_public_path__ + "static/media/audace.4f089168.jpg";